<template>
    <div comp="mvtMarketTrendsCTA" class="inline outline corner bg-default" v-if="geoInfo.marketTrendsPath">
        <div class="flex left middle">
            <i v-if="newDpp" class="icon-graph-increasing"></i>
            <i v-else class="circle default large icon icon-statistics-report">
            </i>
            <div class="content">
                <div v-if="newDpp">Want to know more about the {{geoInfo.city}} real estate market?</div>
                <div v-else>Wondering how {{geoInfo.city}} real estate market is?</div>
                <a :href="glb.appUrl + geoInfo.marketTrendsPath" class="link">See more statistics & trends <i v-if="newDpp" class="icon-angle-right"></i></a>
            </div>
        </div>
    </div>
</template>
<script src="./mvt-markettrendscta.js"></script>

<style lang="scss">
@use './mvt-markettrendscta.scss' as *;
</style>
